import { createSlice } from '@reduxjs/toolkit';
import { initialState, SLICE_NAMESPACE } from './constants';
import { reducers } from './reducers';

const { actions, reducer } = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers,
});

export const { clearUserSessionState, setUserRole, setSubject, setRoleError, clearRoleError } = actions;
export default reducer;
